import React from 'react';
import instantaneo from './Img/productos/CloroInstantaneo.jpg';
import granulado from './Img/productos/CloroGranulado.jpg';
import pastillas from './Img/productos/pastillas.jpg';
import natabio from './Img/productos/natabio.jpg';
import clarificador from './Img/productos/clarificador.jpg';
import alguicida from './Img/productos/alguicida.jpg';
import lona from './Img/productos/Lona.jpg';
import insectos from './Img/productos/insectos.jpg';
import hongos from './Img/productos/tecnocorHongos.jpg';
import alguicidaUny from './Img/productos/AlguicidaUnyclor.png';
import clarificadorUny from './Img/productos/ClarificadorUnyclor.jpg';
import unybio from './Img/productos/Unybio.png';
import superalguicida from './Img/productos/SuperalguicidaUnyclor.png';
import gelclarificador from './Img/productos/GelClarificador.jpg';

function Productos() {
  // Datos de productos organizados por marca
  const unyProducts = [
    { id: 1, src: superalguicida, title: "Súper Alguicida" },
    { id: 2, src: gelclarificador, title: "Gel Clarificador" },
    { id: 3, src: unybio, title: "Unybio" },
    { id: 4, src: clarificadorUny, title: "Clarificador" },
    { id: 5, src: alguicidaUny, title: "Alguicida" }
  ];

  const nataProducts = [
    { id: 1, src: instantaneo, title: "Cloro instantáneo" },
    { id: 2, src: granulado, title: "Cloro granulado" },
    { id: 3, src: pastillas, title: "Pastillas multiacción" },
    { id: 4, src: natabio, title: "Natabio" },
    { id: 5, src: clarificador, title: "Clarificador" },
    { id: 6, src: alguicida, title: "Alguicida" },
    { id: 7, src: lona, title: "Pileta de lona" },
    { id: 8, src: insectos, title: "Producto para insectos" },
    { id: 9, src: hongos, title: "Producto para hongos" }
  ];

  return (<>
    <br/><br/><br/><br/><br/><br/>
    <div className="productos-container">
      <div className="header-section">
        <div className="text-center p-4 bg-light rounded-4 shadow-sm textobox">
          <h2 className="textoproductos display-6 fw-semibold mb-4">
            Tenemos todo lo necesario para mantener tu piscina en perfectas condiciones
          </h2>
          <a href="calculoproductos" className="btn btn-primary btn-lg px-4 py-3 custom-link h2">
            ¿Cuánto producto necesito para mi pileta? ¡Descubrilo!
          </a>
        </div>
        <br />
      </div>

      {/* Carrusel UNYCLOR - Versión móvil (1 producto por slide) */}
      <div className="d-block d-md-none">
        <h1 className="text-center mb-4 brand-title">UNYCLOR</h1>
        <div id="carouselUnyMobile" className="carousel carousel-dark slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {unyProducts.map((product, index) => (
              <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={product.id}>
                <div className="d-flex justify-content-center">
                  <div className="card mobile-card">
                    <img src={product.src} className="card-img-top" alt={product.title} />
                    <div className="card-body">
                      <h6 className="card-title text-center">{product.title}</h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselUnyMobile" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselUnyMobile" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* Carrusel UNYCLOR - Versión escritorio (múltiples productos por slide) */}
      <div className="d-none d-md-block">
        <h1 className="text-center mb-4 brand-title">UNYCLOR</h1>
        <div id="carouselUnyDesktop" className="carousel carousel-dark slide w-100 p-5" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="row card-wrapper d-flex justify-content-around">
                {unyProducts.slice(0, 3).map(product => (
                  <div className="col-md-4" key={product.id}>
                    <div className="card h-100">
                      <img src={product.src} className="card-img-top" alt={product.title} />
                      <div className="card-body d-flex flex-column justify-content-end">
                        <h6 className="card-title text-center">{product.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="carousel-item">
              <div className="row card-wrapper d-flex justify-content-around">
                {unyProducts.slice(3).map(product => (
                  <div className="col-md-4" key={product.id}>
                    <div className="card h-100">
                      <img src={product.src} className="card-img-top" alt={product.title} />
                      <div className="card-body d-flex flex-column justify-content-end">
                        <h6 className="card-title text-center">{product.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselUnyDesktop" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselUnyDesktop" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <br /><br />

      {/* Carrusel NATACLOR - Versión móvil (1 producto por slide) */}
      <div className="d-block d-md-none">
        <h1 className="text-center mb-4 brand-title">NATACLOR</h1>
        <div id="carouselNataMobile" className="carousel carousel-dark slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {nataProducts.map((product, index) => (
              <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={product.id}>
                <div className="d-flex justify-content-center">
                  <div className="card mobile-card">
                    <img src={product.src} className="card-img-top" alt={product.title} />
                    <div className="card-body">
                      <h6 className="card-title text-center">{product.title}</h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselNataMobile" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselNataMobile" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* Carrusel NATACLOR - Versión escritorio (múltiples productos por slide) */}
      <div className="d-none d-md-block">
        <h1 className="text-center mb-4 brand-title">NATACLOR</h1>
        <div id="carouselNataDesktop" className="carousel carousel-dark slide w-100 p-5" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="row card-wrapper d-flex justify-content-around">
                {nataProducts.slice(0, 3).map(product => (
                  <div className="col-md-4" key={product.id}>
                    <div className="card h-100">
                      <img src={product.src} className="card-img-top" alt={product.title} />
                      <div className="card-body d-flex flex-column justify-content-end">
                        <h6 className="card-title text-center">{product.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="carousel-item">
              <div className="row card-wrapper d-flex justify-content-around">
                {nataProducts.slice(3, 6).map(product => (
                  <div className="col-md-4" key={product.id}>
                    <div className="card h-100">
                      <img src={product.src} className="card-img-top" alt={product.title} />
                      <div className="card-body d-flex flex-column justify-content-end">
                        <h6 className="card-title text-center">{product.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="carousel-item">
              <div className="row card-wrapper d-flex justify-content-around">
                {nataProducts.slice(6).map(product => (
                  <div className="col-md-4" key={product.id}>
                    <div className="card h-100">
                      <img src={product.src} className="card-img-top" alt={product.title} />
                      <div className="card-body d-flex flex-column justify-content-end">
                        <h6 className="card-title text-center">{product.title}</h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselNataDesktop" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselNataDesktop" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

export default Productos;